import React,{useState} from 'react';
import Select from 'react-select';
import styled from "styled-components"


const CircleSelector = ({ liabilitiesGetCircleNames }) => {
    const [isDisabled,setIsDisabled] = useState(false);
    const options = liabilitiesGetCircleNames.map((circle) => ({ label: circle, value: circle}));
    return(
        <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled? 0.5: 1}`}}>
            <Select options={options} 
                onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
                isDisabled = {isDisabled}
                placeholder = {'Please Select Circle'}
            />
        </div>
    );
}

//*************** liabilitiesGetRechargePlans ***************
//old code**
// const BillPlanSelector = ({ liabilitiesGetRechargePlans }) => { 
//     const [isDisabled,setIsDisabled] = useState(false);
//     const options = liabilitiesGetRechargePlans.map(({biller_name,plan_description,amount}) => ({ label: `${amount} / ${biller_name} / ${plan_description}`, value: amount}));
//     return(
//         <div className="select-container" style={{width: '300px',maxWidth: '100%',opacity:`${isDisabled?0.5:1}`}}>
//             <Select options={options} 
//                 onChange={opt => {window['autosubmit'](opt.value);setIsDisabled(true)}}
//                 isDisabled = {isDisabled}
//                 placeholder = {'Please Select Recharge Plan'}
//             />
//         </div>
//     );
// }

const BillPlanSelector = (props) => {
    const {liabilitiesGetRechargePlans} = props;

    // const [isDisabled,setIsDisabled] = useState(false);

    const handleSelectClick = (selection) => {

    //    if(selection == "enterRechargeAmount"){
    //         let inputString = 'Enter Recharge Amount';
    //         window['autosubmit'](inputString);

    //    }

    }

    return(
        <div id="select-block" style={{marginTop: "16px"}}>
             <div className="action-elem"
                // onClick={() => {props.overlayRechargeToggle(dummyData)}}//comment this..
                 onClick={() => {props.overlayRechargeToggle(liabilitiesGetRechargePlans)}}
                >View Plan
            </div>
          
        </div>
    );
}
//
// let liabilitiesUbpSummary2 = {
//         "BillerName": "Airtel Prepaid", 
//         "Amount": "500",
//         "Authenticators": [
//           {
//             "ParameterName": "Mobile Number",
//             "Value": "9876543210"
//           },
//           {
//             "ParameterName": "Gas Number",
//             "Value": "256434"
//           }
//         ]
//   }

const UbpSummary = ({liabilitiesUbpSummary, NoConfirmButton}) => {

    const handleClick = () => {
        let inputString =  "Confirm" + "<split>" + "Confirm"
        window['autosubmit'](inputString);
    
      }


    //   console.log(Object.keys(liabilitiesUbpSummary)[0],Object.values(liabilitiesUbpSummary)[0]);
      
    
    const showBillerSummary = ()=>{
        
        return liabilitiesUbpSummary.Authenticators.map((item,i)=>{
           // console.log(item);
            return(
                <PaymentDetail key={i}>


                    {(item.ParameterName == undefined && item.Value == undefined)?null:
                    <BillerRow>
                       <BillerLabel>{item.ParameterName}: </BillerLabel>
                       <BillerValue>{item.Value}</BillerValue>
                    </BillerRow>}
              
                </PaymentDetail>
            )
        });
    }
    return (
        <React.Fragment>
            {/* <PaymentTitle>
                Summary
            </PaymentTitle> */}

            {/* <DashBorder/> */}

            {/* {showBillerSummary()} */}


            {/* <BillerRow>
                <BillerLabel>{Object.keys(liabilitiesUbpSummary)[0]}</BillerLabel>
                <BillerValue>{Object.Value(liabilitiesUbpSummary)[0]}</BillerValue>
            </BillerRow> */}

            {showBillerSummary()}

            {liabilitiesUbpSummary.BillerName == undefined?null:
            <BillerRow>
                <BillerLabel>Biller Name:</BillerLabel>
                <BillerValue>{liabilitiesUbpSummary.BillerName}</BillerValue>
            </BillerRow>}
            
            {liabilitiesUbpSummary.Amount == undefined?null:
            <BillerRow>
                <BillerLabel>Amount:</BillerLabel>
                <BillerValue>₹ {liabilitiesUbpSummary.Amount}</BillerValue>
            </BillerRow>}

            {liabilitiesUbpSummary.Frequency == undefined?null:
            <BillerRow>
                <BillerLabel>Frequency:</BillerLabel>
                <BillerValue>{liabilitiesUbpSummary.Frequency}</BillerValue>
            </BillerRow>}
      
            {liabilitiesUbpSummary.CreditCard == undefined?null:
            <BillerRow>
                <BillerLabel>Credit Card:</BillerLabel>
                <BillerValue>{liabilitiesUbpSummary.CreditCard}</BillerValue>
            </BillerRow>}

            {NoConfirmButton?<ActionButton className="action-elem"
                onClick={()=>handleClick()}>Confirm</ActionButton>:null}
            
            <div className="action-elem" style={{display:"none"}}></div> 
        </React.Fragment>
    );
};

const PaymentDetail = styled.div`
min-width:280px;
margin-top : 2px;
`
const PaymentTitle = styled.div`
color:green;
font-weight:600;
font-size:18px;
text-align: center;
`
const DashBorder = styled.div`
margin-top:10px;
margin-bottom:16px;
border: 0.4px dashed #666666; 
`
const BillerRow =styled.div`
font-size:12px;
padding: 8px 0px;
border-bottom:1px solid rgba(0,0,0,0.03);
`
const BillerLabel = styled.div`
display: inline-block;
vertical-align:middle;
width:40%;
color: #666666;
text-align: left;
margin:0px;
`
const BillerValue = styled.div`
display: inline-block; 
vertical-align:middle; 
width:60%;
color: #666666;
text-align: right;
font-weight:550;
margin:0px;

`
const ActionButton = styled.div`

  width: 32%;
  margin: 0 auto;
  margin-top: 20px;
  border: 0px solid #2c387a;
  background: #2c387a;
  color: #fff;

`

export default CircleSelector;

export {BillPlanSelector, UbpSummary};